import { FC, useEffect, useState } from 'react';
import { Loading, Section, Table, Input, Button } from '../../../../components';
import { useToastStore } from '../../../../stores';
import { TReportShopkeeperWithoutPurchase, postLojistaNaoCompra } from '../../../../services';
import {
	Form,
	HalfLine,
	HalfLineButton,
	NoData,
	Separator,
	TableWrapper,
	TitleContainer,
} from '../../Reports.styles';

const AdminShopkeeperWithoutPurchase: FC = () => {
	const { setToast } = useToastStore();
	const [loading, setLoading] = useState(false);
	const [filteredOffers, setFilteredOffers] = useState<TReportShopkeeperWithoutPurchase[]>([]);
	const [startDate, setStartDate] = useState('');
	const [endDate, setEndDate] = useState('');
	const [clickGenerate, setClickGenerate] = useState(false);

	const fetchDataReport = async () => {
		if (startDate && endDate && endDate >= startDate) {
			setLoading(true);
			const body = {
				dataInicial: startDate + 'T00:00:00.000Z',
				dataFinal: endDate + 'T23:59:59.999Z',
			};
			const data = await postLojistaNaoCompra(body) || [];
			const lojistasFiltrados = data.map((item) => ({
				id: item.id ?? 0,
				razaoSocial: item.razaoSocial ?? '',
				fantasia: item.fantasia ?? '',
				numeroDocumento: item.numeroDocumento ?? '',
				email: item.email ?? '',
				telefone: item.telefone ?? '',
				celular: item.celular ?? '',
				cidade: item.cidade ?? '',
				estado: item.estado ?? '',
			}));

			if (!data) {
				setToast({ variant: 'error', message: 'Erro ao buscar dados!' });
				return;
			}

			setFilteredOffers(lojistasFiltrados);
			setLoading(false);
			setClickGenerate(true);
		}
	};

	useEffect(() => {
		if (!startDate || !endDate) return;

		if (new Date(startDate).getTime() > new Date(endDate).getTime()) {
			setEndDate(startDate);
		}
	}, [startDate, endDate]);

	const tableColumns = [
		{
			id: 'name',
			label: 'Razão Social',
		},
		{
			id: 'comercialName',
			label: 'Nome Fantasia',
		},
		{
			id: 'document',
			label: 'CNPJ/CPF',
		},
		{
			id: 'phones',
			label: 'Telefones',
		},
		{
			id: 'email',
			label: 'E-mail',
		},
		{
			id: 'city',
			label: 'Cidade',
		},
		{
			id: 'state',
			label: 'Estado',
		},
	];

	const rowMapper = (item: TReportShopkeeperWithoutPurchase) => ({
		name: { value: item?.razaoSocial, rawValue: item?.razaoSocial },
		comercialName: { value: item?.fantasia, rawValue: item?.fantasia },
		document: { value: item?.numeroDocumento, rawValue: item?.numeroDocumento },
		phones: {
			value: (item?.telefone && item?.celular) ? `${item?.telefone} / ${item?.celular}` : ( item?.telefone ? item?.telefone : ( item?.celular ? item?.celular : ``)),
			rawValue: (item?.telefone && item?.celular) ? `${item?.telefone} / ${item?.celular}` : ( item?.telefone ? item?.telefone : ( item?.celular ? item?.celular : ``)),
		},
		email: { value: item?.email, rawValue: item?.email },
		city: { value: item?.cidade, rawValue: item?.cidade },
		state: { value: item?.estado, rawValue: item?.estado },
	});

	return (
		<>
			<Section>
				<TitleContainer>Revendas sem compras</TitleContainer>
				<Separator />
				<Form>
					<HalfLine>
						<Input
							label='Data de Cadastro Inicial'
							variant='text'
							value={startDate}
							onChange={(e) => {
								setStartDate(e.target.value);
							}}
							type='date'
						/>
					</HalfLine>
					<HalfLine>
						<Input
							label='Data de Cadastro Final'
							variant='text'
							value={endDate}
							onChange={(e) => {
								setEndDate(e.target.value);
							}}
							type='date'
							min={startDate}
						/>
					</HalfLine>
					<HalfLineButton>
						<Button
							variant='large'
							fitContent
							onClick={fetchDataReport}
							disabled={!startDate || !endDate}
						>
							Gerar
						</Button>
					</HalfLineButton>
				</Form>
				{loading && (
					<NoData>
						<Loading />
					</NoData>
				)}
				{!loading && filteredOffers.length > 0 && (
					<TableWrapper>
						<Table
							title='Revendas sem compras'
							columns={tableColumns}
							rows={filteredOffers.map(rowMapper)}
							exportToPDF
							exportToCSV
						/>
					</TableWrapper>
				)}
				{!loading && clickGenerate && filteredOffers.length === 0 && (
					<NoData>Nenhum registro encontrado</NoData>
				)}
			</Section>
		</>
	);
};

export default AdminShopkeeperWithoutPurchase;
